import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IGetImportManifestParams, IImportManifest } from '../types/IBundleImport';

/**
 * The VizPortal `getImportManifest` Web Client method (CM `getImportManifest`): the summary counts and
 * one page of per-item outcomes of an import, keyed on its background job id.
 */
export class GetImportManifestRequest extends Request<IGetImportManifestParams, IImportManifest> {
  constructor(params: IGetImportManifestParams) {
    super('getImportManifest', params);
  }
}
